import Page from "../../../layout/Page";

import {useTranslation} from "react-i18next";
import usePagination from "../../../util/usePagination";
import teamService from "../../../service/TeamService";
import {DataTable} from "../../../components/DataTable";
import Container from '@mui/material/Container';
import ListPageActions from "../../../components/ListPageActions";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import AddButton from "../../../ui/AddButton";
import DeleteDialog from "../../../components/DeleteDialog";

const TeamListPage = ({title}) => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [selected, setSelected] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const columns = [
        {
            name: "name",
            label: t('label.name'),
            searchable: true
        }
    ];

    const teams = usePagination({
        service: teamService
    })

    const ActionButtons = () => (
        <ListPageActions>
            <AddButton onClick={() => {
                navigate(`/commons/teams/create`)
            }}/>
        </ListPageActions>
    )

    return (
        <Page title={title}>
            <Container maxWidth={"md"}>
                <ActionButtons/>
                <DataTable
                    title={t('title.teamList')}
                    columns={columns} {...teams}
                    onEdit={(item) => {
                        navigate(`/commons/teams/edit/${item._id}`);
                    }}
                    onDelete={(item) => {
                        setSelected(item);
                        setOpenDeleteDialog(true);
                    }}
                />
                <ActionButtons/>
            </Container>

            <DeleteDialog
                item={selected}
                itemService={teamService}
                message={selected?.name}
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                    setSelected(null)
                }}
                onDoneCallback={teams.search}
            />
        </Page>
    );
}

export default TeamListPage;
